module.exports = __webpack_public_path__ + "static/media/BoxPlotQ1_5.38fe7afa.svg";